module.exports = __webpack_public_path__ + "img/personal-bg.39b89429.jpg";